<lib-lib-demande-analyse-devis  [configuration]="configuration" [fileNamePattern]="fileNamePattern">
</lib-lib-demande-analyse-devis>
